var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"focus:outline-none age-preview-area border-gray-100 border",style:({ height: _vm.height }),attrs:{"id":("" + _vm.rID)}})}
var staticRenderFns = []

export { render, staticRenderFns }